import { httpRequest } from "../../http";

export class CommandDeleteFolder {
  async run(organizationId: number, folderId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/${organizationId}/folders/${folderId}/`;

    try {
      const response = await httpRequest<any>(url, { method: "DELETE" });
      return response;
    } catch (error) {
      console.error("Error deleting folder:", error);
      throw error;
    }
  }
}
